// extracted by mini-css-extract-plugin
export default {"addressItem":"addressItem---o4khZ","addressItemContent":"addressItemContent---rkV3W"};